<template>
  <!-- Seaded -> Planeerija uues kujunduses: the new look, unless this person
       chose the old one (Minu seaded, or the button on either page). -->
  <planner-plate v-if="plate" :readonly="readonly" @use-old="choose('vana')" />
  <loading-content v-else :loading="loading">
    <div class="d-flex flex-wrap align-center justify-space-between ga-2">
      <h1>Planeerija</h1>
      <v-btn v-if="features.plannerPlate" variant="outlined" color="green" @click="choose('uus')">Uus vaade</v-btn>
    </div>
    <datepicker v-model="date" label="Kuu" type="month" />
    <div class="mb-5">
      <!-- Vuetify 3 draws a chip's filter tick only inside a v-chip-group,
           which would also let a second click unpick the workday. The tick is
           said here instead, as Vuetify 2 drew it: in front of the name.
           variant="flat" because a coloured chip is tonal in v3. -->
      <v-chip
        v-for="workday in chips"
        :key="workday.id"
        class="mr-2"
        :color="'#' + workday.color"
        variant="flat"
        :prepend-icon="selectedWorkday === workday ? 'mdi-check' : undefined"
        :link="!readonly"
        @click="pick(workday)"
      >{{workday.name}}</v-chip>
    </div>
    <template v-if="technics.length && workdays.length">
      <planner-month
        v-for="month in months"
        :key="month.start.toISOString()"
        :startDate="month.start"
        :endDate="month.end"
        :technics="technics"
        :workdays="workdays"
        :selectedWorkday="selectedWorkday"
        :readonly="readonly"
        class="mt-10"
      />
    </template>
  </loading-content>
</template>

<script>
import api from './../api'
import dayjs from 'dayjs'
import { mapActions, mapGetters, mapState } from 'vuex'
import PlannerMonth from '@/components/PlannerMonth.vue'
import Datepicker from '@/components/input/Datepicker.vue'
import PlannerPlate from './PlannerPlate.vue'

export default {
  components: { PlannerMonth, Datepicker, PlannerPlate },
  data () {
    return {
      loading: true,
      date: undefined,
      technics: [],
      workdays: [],
      selectedWorkday: null
    }
  },
  watch: {
    date () {
      this.$router
        .push({ name: 'planner', params: { date: dayjs(this.date).format('YYYY-MM') }})
        .catch(() => {})
    }
  },
  computed: {
    ...mapState(['features', 'prefs']),
    ...mapGetters(['isAdmin', 'isSecretary']),
    // Only the office fills the planner in; a technician reads it, and the
    // workday chips are then just the key to the colours.
    readonly () {
      return !(this.isAdmin || this.isSecretary)
    },
    // The switch decides for everyone; a person may keep the old page.
    plate () {
      return !!(this.features && this.features.plannerPlate) && this.prefs.plannerLook !== 'vana'
    },
    // "Kustuta" (the stored 'tyhi' workday) is a tool, not a kind of day.
    chips () {
      return this.readonly ? this.workdays.filter(workday => workday.title !== 'tyhi') : this.workdays
    },
    months () {
      const months = []
      const total = 3
      let start = dayjs(this.date).startOf('month')
      const end = dayjs(start).add(total, 'month')

      while (start.isBefore(end)) {
        months.push({
          start,
          end: dayjs(start).endOf('month')
        })
        start = start.add(1, 'month').startOf('month')
      }

      return months
    }
  },
  methods: {
    ...mapActions(['getPrefs', 'savePrefs']),
    choose (look) {
      this.savePrefs({ plannerLook: look })
    },
    pick (workday) {
      if (!this.readonly) this.selectedWorkday = workday
    }
  },
  created () {
    this.getPrefs()
  },
  async mounted () {
    this.date = dayjs(this.$route.params.date || undefined).startOf('month').format('YYYY-MM')
    await Promise.all([
      api.getPlannerUsers().then(({ users }) => this.technics = users),
      api.getWorkdays().then(({ workdays }) => this.workdays = workdays)
    ])
    this.loading = false
  }
}
</script>
